import { render, staticRenderFns } from "./InvoiceHistroy.vue?vue&type=template&id=1135d01c&scoped=true"
import script from "./InvoiceHistroy.vue?vue&type=script&lang=js"
export * from "./InvoiceHistroy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1135d01c",
  null
  
)

export default component.exports